import { FormattedMessage } from 'react-intl';
import { Button, ButtonContentWithLoader, ButtonVariant } from '@edikk-edikk/country-layout-black';
import { FC } from 'react';
import { useReviewCheckHandlerClick, useReviewCheckToggleContext } from '#baseMenu/components';
import { useAdvertReviewCheckVisibleControl } from '#reviewCheck/hooks';
import { useMenuState } from '#baseMenu/hooks';

const ReviewCheckToggleButton: FC = () => {
  const { isOpen } = useAdvertReviewCheckVisibleControl();
  const { isLoadInProcess } = useReviewCheckToggleContext();
  const { isActionsBlocked } = useMenuState();
  const handlerClick= useReviewCheckHandlerClick();

  return (
    <Button
      variant={isOpen ? ButtonVariant.white65 : ButtonVariant.black65}
      pill
      textUppercase
      onClick={handlerClick}
      additionalClassName="flex-grow-1"
      pointerEventsNone={isActionsBlocked}
    >
      <ButtonContentWithLoader isLoading={isLoadInProcess} content={<FormattedMessage defaultMessage="Reviews" />} />
    </Button>
  );
};

export { ReviewCheckToggleButton };
